import { z } from "zod";
import { PaymentStatus } from "../payment";
import { OrderStatus } from "./order";

export const OrderMassUpdatePayloadSchema = z.object({
  order_ids: z.array(z.string()).min(1).max(500),
  status: z.nativeEnum(OrderStatus).optional(),
  payment_status: z.nativeEnum(PaymentStatus).optional(),
  preffered_date: z.string().nullable().optional(),
}).refine(
  (payload) =>
    payload.status !== undefined ||
    payload.payment_status !== undefined ||
    payload.preffered_date !== undefined,
  { message: "Select at least one field to update." },
);

export const OrderMassUpdateResponseSchema = z.object({
  updated_count: z.number().int().nonnegative(),
});

export type OrderMassUpdatePayload = z.infer<
  typeof OrderMassUpdatePayloadSchema
>;
export type OrderMassUpdateResponse = z.infer<
  typeof OrderMassUpdateResponseSchema
>;
